import React from "react";
import {useDismissOverlayOnMount} from "@commons/Hooks";
import ResponsivePicture from "@components/ResponsivePicture/ResponsivePicture";
import PageSection from "@components/Page/PageSection";
import {OnboardForm} from "@pages/Onboard/Components/OnboardForm/OnboardForm";
import "./OnboardPage.scss";
import Page from "@components/Page/Page";
import PageContent from "@components/Page/PageContent";
import {usePublicTranslations} from "@i18n/i18nUtils";
import DesktopBanner from "@assets/images/onboard/Accesso-Home-540x767.jpg";
import MobileBanner from "@assets/images/onboard/Accesso-Home-375x270.jpg";
import {useAuth} from "@msal/useAuth";
import {buildRoute} from "@router/RouterUtils";
import {AppRoute} from "@router/RoutingModels";
import {useNavigate} from "react-router-dom";
import {useAppContextStore} from "@store/AppContextStore";
import {useShallow} from "zustand/react/shallow";

export function OnboardPage() {

    useDismissOverlayOnMount();

    const navigate = useNavigate();

    const {t} = usePublicTranslations();

    const {isAuthenticated} = useAuth();

    const {status, statusReason} = useAppContextStore(useShallow(s => ({
        status: s.status,
        statusReason: s.statusReason,
    })));

    if (!isAuthenticated) {
        navigate(buildRoute(AppRoute.WELCOME));
        return;
    }

    if (isAuthenticated && statusReason === null && (status === "ready" || status === "idle")) {
        navigate(buildRoute(AppRoute.HOME));
        return;
    }

    return (
        <>
            <Page>

                <PageContent>
                    <PageSection className={"bg-dark"}>

                        <div className="onboard">

                            <div className="onboard__media">
                                <ResponsivePicture
                                    alt="Home privata"
                                    images={[
                                        MobileBanner,
                                        DesktopBanner,
                                    ]}
                                />
                                <div className="onboard__media__content">

                                </div>
                            </div>

                            <div className="onboard__content">

                                <div className="onboard__content__header">
                                    <h1 className={"tp-l"}
                                        dangerouslySetInnerHTML={{__html: t("public.onboard.title")}}/>
                                    <h2 className={"tp-m"}
                                        dangerouslySetInnerHTML={{__html: t("public.onboard.subtitle")}}/>
                                </div>

                                <div className="onboard__content__form">
                                    <OnboardForm/>
                                </div>

                            </div>

                        </div>

                    </PageSection>
                </PageContent>

            </Page>

        </>
    );
}
